export const GET_STATS = "GET_STATS";
export const GET_DOCTOR_LIST = "GET_DOCTOR_LIST";
export const GET_SEARCH_RESULT = "GET_SEARCH_RESULT";
export const GET_ADMIN_REPORTS = "GET_ADMIN_REPORTS";